// Hmong translations
export const hmn: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Cov Neeg Yuav',
  'menu.products': 'Cov Khoom',
  'menu.users': 'Cov Neeg Siv',
  'menu.settings': 'Chaw',
  'menu.logout': 'Tawm',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Xaj Tshiab',
  'order.title': 'Xaj Tshiab',
  'order.customer': 'Neeg Yuav',
  'order.products': 'Cov Khoom',
  'order.total': 'Tag Nrho',
  'users.title': 'Cov Neeg Siv',
  'users.name': 'Lub Npe',
  'users.email': 'Email',
  'common.yes': 'Yog',
  'common.no': 'Tsis Yog',
  'common.cancel': 'Tshem Tawm',
  'common.save': 'Txuag',
  'common.search': 'Nrhiav',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Nkag',
  'login.welcome': 'Zoo siab txais tos, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Xov Tooj',
  'menu.reportsAndAccounting': 'Cov Ntawv Qhia & Kev Suav Nyiaj',
  'menu.systemAndCommunication': 'Txheej Txheem & Kev Sib Txuas Lus',
};